import { GetStaticProps, InferGetStaticPropsType, NextPage } from 'next';

import {
  FooterDocument,
  FooterQuery,
  FooterQueryVariables,
  NavigationDocument,
  NavigationQuery,
  NavigationQueryVariables,
  WhistleblowingPolicyDocument,
  WhistleblowingPolicyQuery,
  WhistleblowingPolicyQueryVariables,
} from '@/api';
import { addApolloState, initializeApollo } from '@/api/apolloClient';
import { Layout } from '@/components/layout/Layout';
import { Seo } from '@/components/Seo';
import EnhancedPolicyPageWrapper from '@/components/shared/EnhancedPolicyPageWrapper';

export const getStaticProps: GetStaticProps = async () => {
  const client = initializeApollo();

  // prefetch
  await client.query({ query: NavigationDocument });
  await client.query({ query: FooterDocument });
  await client.query({ query: WhistleblowingPolicyDocument });

  const { data: whistleblowingPolicy } = await client.query<
    WhistleblowingPolicyQuery,
    WhistleblowingPolicyQueryVariables
  >({
    query: WhistleblowingPolicyDocument,
  });

  const { data: footerData } = await client.query<
    FooterQuery,
    FooterQueryVariables
  >({ query: FooterDocument });

  const { data: headerData } = await client.query<
    NavigationQuery,
    NavigationQueryVariables
  >({ query: NavigationDocument });

  return addApolloState(client, {
    props: {
      footerData,
      headerData,
      whistleblowingPolicy,
    },
  });
};

const WhistleblowingPolicy: NextPage<
  InferGetStaticPropsType<typeof getStaticProps>
> = ({ footerData, headerData, whistleblowingPolicy }) => (
  <Layout invertedColor footerData={footerData} headerData={headerData}>
    <Seo
      seo={whistleblowingPolicy.whistleblowingPolicy?.data?.attributes?.seo}
    />
    <EnhancedPolicyPageWrapper
      data={
        whistleblowingPolicy.whistleblowingPolicy?.data?.attributes?.policies
      }
    />
  </Layout>
);

export default WhistleblowingPolicy;
